import { stringFromJSONValue } from './parser'

export class CityModel {
  public city: string
  public stateOrProvidence: string
  public country: string

  public constructor(city: string, stateOrProvidence: string, country: string) {
    this.city = city
    this.stateOrProvidence = stateOrProvidence
    this.country = country
  }

  public static modelFromJSON(json: any): CityModel {
    return new CityModel(
      stringFromJSONValue(json['City']),
      stringFromJSONValue(json['StateProv']),
      stringFromJSONValue(json['Country'])
    )
  }
}
